export default "__VITE_ASSET__BekIiaSx__"